"use client";

import { useEffect, useRef, useState } from "react";

export function useCounterAnimation(
  target: number,
  duration = 2000,
  format?: (val: number) => string
) {
  const [display, setDisplay] = useState("0");
  const ref = useRef<HTMLElement>(null);
  const fired = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !fired.current) {
            fired.current = true;
            let start: number | null = null;
            function step(ts: number) {
              if (!start) start = ts;
              const p = Math.min((ts - start) / duration, 1);
              const ease = 1 - Math.pow(1 - p, 3);
              const val = Math.round(target * ease);
              setDisplay(format ? format(val) : val.toLocaleString("fr-FR"));
              if (p < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [target, duration, format]);

  return { ref, display };
}
